import React from 'react';
import { GenericDetailPage } from '../../components/generic';
import { useAppointment, Appointment } from './useData';
import { moduleConfig, getDetailSections, getStatusBadges } from './config';

const Detail: React.FC = () => {
  return (
    <GenericDetailPage<Appointment>
      useData={useAppointment}
      config={{
        ...moduleConfig,
        getDetailSections,
        getStatusBadges,
      }}
    />
  );
};

export default Detail;

